import React from 'react';
import withIcon from '../utilities/withIcon';

const IconBell = () => {
  return (
    <g>
      <path d="m14.4976 12.4153-1.0464-3.13v-2.0053a5.455 5.455 0 0 0 -4.7012-5.3938v-1.1076a.75.75 0 1 0 -1.5 0v1.1076a5.455 5.455 0 0 0 -4.7007 5.3938v2.0049l-1.0469 3.13a.75.75 0 0 0 .7114.9878h3.2062a2.58 2.58 0 0 0 5.16 0h3.2059a.75.75 0 0 0 .7114-.9878zm-6.4976 2.0561a1.0811 1.0811 0 0 1 -1.0784-1.0684h2.1573a1.0815 1.0815 0 0 1 -1.0789 1.0684zm-4.7446-2.5683.7554-2.2583a.7556.7556 0 0 0 .0386-.2378v-2.127a3.9509 3.9509 0 1 1 7.9018 0v2.127a.7556.7556 0 0 0 .0386.2378l.7549 2.2583z" />
    </g>
  );
};

export default withIcon(IconBell);
